<template>
  <div>
    <!--HEADER-->
    <div id="Header">
      <div id="Header-content" class="container">
        <div class="row">
            <span v-show="isCPM">
              <div :class="logo_width">
                <a class="cpms-logo d-none d-md-block" id="logo" :href="portalUrl"><img src="./assets/CPMS.png" alt="logo"/></a>
                <a class="cpms-logo-mobile d-block d-md-none" id="logo-mobile" :href="portalUrl"><img src="./assets/CPMS.png" alt="logo"/></a>
              </div>
            </span>
          <div v-show="isACS" :class="logo_width">
            <a class="acs-logo" id="logo" :href="portalUrl"><img src="./assets/ACS.png" alt="logo"/></a>
          </div>
          <div v-show="isGSA" :class="logo_width">
            <a class="gsa-logo d-none d-md-block" id="logo" :href="portalUrl"><img src="./assets/GSA.png" alt="logo"/></a>
            <a class="gsa-logo d-block d-md-none" id="logo-mobile-gsa" :href="portalUrl"><img src="./assets/GSA.png" alt="logo"/></a>
          </div>
          <div v-show="isMGD" :class="logo_width">
            <a class="mgd-logo" id="logo" :href="portalUrl"><img src="./assets/MGD.png" alt="logo"/></a>
          </div>
          <div id="Page-title" :class="title_width">
            <h5 class="d-md-block d-none text-left">{{ text.title }}</h5>
            <h6 class="d-md-none d-block text-left">{{ text.title }}</h6>
            <div :class="'text-left underline ' + underlineClass"></div>
          </div>
        </div>
      </div>
    </div>

    <!--CONTENT-->
    <router-view name="main">
      <!--SPECIFIC CONTENT-->
      <router-view 
        name="specific"
        ref="specificForm"
        slot="specific-form">
      </router-view>
    </router-view>
    <br>

    <toaster></toaster>

  </div>
</template>

<script>
import Branding from './helpers/branding'
import resources from './helpers/resources'

export default {
  name: 'app',
  computed:{
    text() { return resources },
    brandCode() { return Branding.getBrandCode() },
    portalUrl() { return Branding.portalUrl() },
    underlineClass() { return Branding.getUnderlineClass() },
    isCPM() { return Branding.getBrandCode() == Branding.CPM },
    isMGD() { return Branding.getBrandCode() == Branding.MGD },
    isACS() { return Branding.getBrandCode() == Branding.ACS },
    isGSA() { return Branding.getBrandCode() == Branding.GSA },
    logo_width() { 
      if(Branding.getBrandCode() == Branding.CPM) return "col-md-2 col-5"
      if(Branding.getBrandCode() == Branding.MGD) return "col-md-2 col-3"
      if(Branding.getBrandCode() == Branding.ACS) return "col-md-2 col-4"
      if(Branding.getBrandCode() == Branding.GSA) return "col-md-2 col-sm-3 col-4"
    },
    title_width() { 
      if(Branding.getBrandCode() == Branding.CPM) return "col-md-10 col-7"
      if(Branding.getBrandCode() == Branding.MGD) return "col-md-10 col-9"
      if(Branding.getBrandCode() == Branding.ACS) return "col-md-10 col-8"
      if(Branding.getBrandCode() == Branding.GSA) return "col-md-10 col-sm-9 col-8"
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue